import React from "react"
import styles from "./index.module.css"

function CSSCounterExample() {
  return (
    <div className={styles.wrapper}>
      <p>First paragraph</p>
      <p>Second paragraph</p>
      <p>Third paragraph</p>
    </div>
  )
}

export default CSSCounterExample
